"use client";

// import { isIOS, isMobileSafari, isSafari } from "react-device-detect";
import { LenisOptions } from "lenis";
import "lenis/dist/lenis.css";
import { ReactLenis } from "lenis/react";
import { LenisRef } from "lenis/react";

function Lenis({
  className = "",
  root = false,
  options = {},
  children,
  ref,
}: {
  className?: string;
  root?: boolean;
  options?: LenisOptions;
  children?: React.ReactNode;
  ref?: React.Ref<LenisRef>;
}) {
  // Lenis jitters on Safari, a lerp value of 0.5 seems to make it less
  // noticeable
  // @see https://github.com/darkroomengineering/lenis/issues/103
  // if (isSafari || isMobileSafari || isIOS) return null;

  return (
    <ReactLenis
      ref={ref}
      className={className}
      root={root}
      options={{ ...options }}
    >
      {children}
    </ReactLenis>
  );
}

export { Lenis };
